import i18n from '@/plugins/vueI18n';

export const reportPeriods = [
  {
    name: i18n.t("GeneralTranslations.Day"),
    value: 1,
  },
  {
    name: i18n.t("GeneralTranslations.4day"),
    value: 4,
  },
  {
    name: i18n.t("GeneralTranslations.Week"),
    value: 7,
  },
  {
    name: i18n.t("GeneralTranslations.Month"),
    value: 31,
  }
]
